import React, { useState, useEffect, FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component"; // Assuming these are properly typed elsewhere
import { useSelector } from "react-redux";
import { RootState } from "../../store/store"; // Adjust this import based on your store configuration

interface PurchaseRequestAsideProps {
    updateSm: (value: boolean) => void; // Function to update state
    sm: boolean; // Boolean state
}

const PurchaseRequestAside: FC<PurchaseRequestAsideProps> = ({ updateSm, sm }) => {
    const { data: allowedRoutes }: any = useSelector(
        (state: RootState) => state.allowedRoutes
    );
    const location = useLocation();

    useEffect(() => {
        sm
            ? document.body.classList.add("toggle-shown")
            : document.body.classList.remove("toggle-shown");
    }, [sm]);

    const isActive = (path: string): string => {
        return location.pathname === path ? "active" : "";
    };

    const LinkTo = ({ path }: { path: string }) => {
        if (!allowedRoutes.includes(path)) {
            return null;
        }
        switch (path) {
            case "add-new-purchase-request":
                return (
                    <Link
                        to="/add-new-purchase-request"
                        className={isActive(`${process.env.PUBLIC_URL}/add-new-purchase-request`)}
                    >
                        <Icon name="plus-fill-c" />
                        <span>Add New</span>
                    </Link>
                );
            case "approvals-purchase-request":
                return (
                    <Link
                        to="/approvals-purchase-request"
                        className={isActive(`${process.env.PUBLIC_URL}/approvals-purchase-request`)}
                    >
                        <Icon name="check-fill-c" />
                        <span>Approvals</span>
                    </Link>
                );
            case "view-purchase-requests":
                return (
                    <Link
                        to="/view-purchase-requests"
                        className={isActive(`${process.env.PUBLIC_URL}/view-purchase-requests`)}
                    >
                        <Icon name="eye-fill" />
                        <span>View</span>
                    </Link>
                );
            case "track-purchase-requests":
                return (
                    <Link
                        to="/track-purchase-requests"
                        className={isActive(`${process.env.PUBLIC_URL}/track-purchase-requests`)}
                    >
                        <Icon name="activity-round-fill" />
                        <span>Tracking</span>
                    </Link>
                );
            case "analytics-purchase-requests":
                return (
                    <Link
                        to="/analytics-purchase-requests"
                        className={isActive(`${process.env.PUBLIC_URL}/analytics-purchase-requests`)}
                    >
                        <Icon name="growth-fill" />
                        <span>Analytics</span>
                    </Link>
                );
            default:
                return null;
        }
    };

    return (
        <div className="card-inner-group">
            <div className="card-inner">
                <div className="user-account-info py-0">
                    <h6 className="overline-title-alt" style={{ fontSize: 14 }}>
                        Purchase Request
                    </h6>
                </div>
            </div>
            <div className="card-inner p-0">
                <ul className="link-list-menu">
                    {[
                        "add-new-purchase-request",
                        "approvals-purchase-request",
                        "view-purchase-requests",
                        "track-purchase-requests",
                        "analytics-purchase-requests",
                    ].map((item) => (
                        <li key={item} onClick={() => updateSm(false)}>
                            <LinkTo path={item} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default PurchaseRequestAside;
